import { render, staticRenderFns } from "./saveProject.vue?vue&type=template&id=bc073618&scoped=true&"
import script from "./saveProject.vue?vue&type=script&lang=js&"
export * from "./saveProject.vue?vue&type=script&lang=js&"
import style0 from "./saveProject.vue?vue&type=style&index=0&id=bc073618&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc073618",
  null
  
)

export default component.exports